import $ from 'jquery';
import modaal from 'modaal';
import * as CONST from '../../common/utils/constants';
import Util from '../../common/utils/ui';

class ModalAgentAdvisor {
    constructor() {
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
		$('.js-agent-advisor-modal').on('click', (e) => {
			// Show modal for desktop
			if (Util.getViewPort() === CONST.ViewPort.Desktop) {
				e.preventDefault();

				$('.js-agent-advisor-modal').modaal({
					content_source: '#agent-advisor-modal',
					start_open: true,
					overlay_opacity: 0.6,
                    after_open: () => {
                        $('.modaal-content-container').removeAttr('role');
                        $('.modaal-close').focus();
                        $('.modaal-content.modaal-focus').attr('aria-modal', 'true');
                        $('.modaal-container').on('keydown', (e) => {
                            if ($(e.target).hasClass('agent-advisor-modal-actions-content') && e.key === 'Tab' && !e.shiftKey) {
                                e.preventDefault();
                                $('.modaal-close').focus();
                            }
                            if ($(e.target).hasClass('modaal-close') && e.key === 'Tab' && !e.shiftKey) {
                                e.preventDefault();
                                $('.js-agent-advisor-modal-phone').focus();
                            }
                            if ($(e.target).hasClass('modaal-close') && e.key === 'Tab' && e.shiftKey) {
                                e.preventDefault();
                                $('.js-agent-advisor-modal-actions-content').focus();
                            }
                            if ($(e.target).hasClass('js-agent-advisor-modal-phone') && e.key === 'Tab' && e.shiftKey) {
                                e.preventDefault();
                                $('.modaal-close').focus();
                            }
                        });
                    }
				});
			}
		});
    }
}

export default ModalAgentAdvisor;

$(() => {
	const modalAgentAdvisor = new ModalAgentAdvisor();
	modalAgentAdvisor.init();
});